import { render } from "./ItemInput.vue?vue&type=template&id=8c4783b4&bindings={\"modelValue\":\"props\",\"canRemove\":\"props\",\"localImg\":\"setup\"}"
import script from "./ItemInput.vue?vue&type=script&lang=js"
export * from "./ItemInput.vue?vue&type=script&lang=js"

import "./ItemInput.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script